import InfoIcon from "@mui/icons-material/InfoOutlined";
import { Box, Link, Typography } from "@mui/material";
import React from "react";
import { generatePath, Link as RouterLink } from "react-router-dom";

import {
  PATH_SELECTED_ACCOUNT_BASE,
  TicketActivityLabel,
  TicketCategory,
  TicketHeadingCategory,
} from "src/constants";
import {
  FeatureFlagNamesEnum,
  TicketActivityEnum,
  TicketActivityFragment,
} from "src/graphql/generated/types";
import { useHasFeatureFlagActivated, useUuid } from "src/hooks";

import { activityContainer, iconStyle, newCategoryStyle } from "./styles";

const MissionAttachedLabel = () => {
  const uuid = useUuid();

  return (
    <Typography display="inline">
      {"Une demande "}
      <Link
        component={RouterLink}
        to={generatePath(`${PATH_SELECTED_ACCOUNT_BASE}/mission-incidents`, { uuid })}
      >
        d'intervention
      </Link>
      {" a été créée pour votre dossier."}
    </Typography>
  );
};

type Props = {
  activityInfo: TicketActivityFragment;
  missionKind?: string | null;
};

export const ActivityInfo = ({ activityInfo, missionKind }: Props) => {
  const { activityType } = activityInfo;
  const isDisplayMissionIncidentsEnabled = useHasFeatureFlagActivated(
    FeatureFlagNamesEnum.CustomerPortalDisplayMissionIncidents
  );

  if (isDisplayMissionIncidentsEnabled && activityType === TicketActivityEnum.MissionAttached) {
    if (missionKind !== "MissionIncident") return null;

    return (
      <Box sx={activityContainer}>
        <InfoIcon color="inherit" sx={iconStyle} />
        <MissionAttachedLabel />
      </Box>
    );
  }

  const ticketActivityLabel = TicketActivityLabel[activityType];

  const ticketCategory =
    activityInfo.metadata?.categoryAfter && TicketCategory[activityInfo.metadata?.categoryAfter];
  const ticketCategoryLabel = [
    ticketCategory?.headingCategory && TicketHeadingCategory[ticketCategory.headingCategory].label,
    ticketCategory?.label,
  ]
    .filter(Boolean)
    .join(" / ");

  if (!ticketActivityLabel) return null;

  return (
    <Box sx={activityContainer}>
      <InfoIcon color="inherit" sx={iconStyle} />

      <Box>
        <Typography display="inline">{ticketActivityLabel}</Typography>{" "}
        <Typography display="inline" sx={newCategoryStyle}>
          {ticketCategoryLabel}
        </Typography>
      </Box>
    </Box>
  );
};
